export class ProyectoLoteModelo {
    precio: number;
    precioModelo: number;
    precioModeloFinal: number;
    terreno: string;
    construccion: string;
    imagen: string;
    plantas: string;
    cantidadGaleria: number;
    estatus: string;
    recorrido: string;
    idModelo?: number = -1;
    idLote?: number = -1;
    idProyecto?: number = -1;
    idLanding: number;
    idPromocion: number;
    idUsuarioUM: number;
    idProspecto: number;
    idEmpresaAfiliada?: number;
    nombre: string;
    montoMin: number;
    montoMax: number;
    fechaHoraUM: string;
    nombreProyecto: string;
    cantidadVentasIndicador: number;
    montoVentasIndicador: number;
    recamaras: number | null;
    banos: number | null;
    areas: number;
    estacionamientos: number | null;
    eliminar: string[];
    imagenes: string[];
    imagenPrincipal: string;
    precio_min_inventario: number;
    unidades_disponibles: number;
    idsProyectos: string;
    fechaInicio: string;
    fechaFin: string;
    cantidad: number;
    pagina: number;
    brochure: number;
    ubicacion: string;
    descripcion: string;
    latitud: number;
    longitud: number;
    idEmpresa: number;
    idsLote: string;
    nombreModelo: string;
    numeroLote: number;
    estatusLote: string;
    m2: number;
    costo: number;
    precioPorM2: number;
    precioM2ex: number;
    m2ex: number;
    // idModelo: number;
    idCierre: number;
    nivel: number;
    etapa: number;
    porcentajeUbicacionLote: number;
    porcentajeUbicacionModelo: number;
    precioLote: number;
    precioFinal: number;
    precioM2Actualizado: number;
    idDisponibilidad: number;
    montoVenta: number;
    lista_precios_activas_simulado: string;
    modeloAsignado: number;
    equipamientos: string;
    idsModelos: string;
    idsEquipamientos: string;
    estatusDisponibilidad: number;
    costoEquipamientos: number;
    seleccionado: number;
    idSeguimientoProspecto: number;
    incrementoLote_precioFinal_validacion: number;
    precioFinal_sin_incremento: number;
    tipoVista: string;
    formaRenta: number = -1;
    idCategoria: number = -1;
    idInfraestructura: number = -1;
    nombreInfraestructura: string = "";
}


export class Lote_Reserva_Precios {
    idLote?: number = -1;
    tipoModalidad?: string = "";
    precio?: number = 0;
    fechaHoraUM?: Date = new Date();
    idUsuarioUM?: number = -1;
}